import { useEffect, useState } from "react";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import TextArea from "../ReusableComponents/TextArea";
import { BindPostAPI } from "../services/APIConnection";
import { mainTable } from "../css/Common";
import UsePrevious from "../Hook/UsePrevious";


const PurchasePopup = ({ data, data1 = [] }) => {

  const [tableData, setTableData] = useState([
    {
      itemType: "",
      ItemCategory: "",
      itemId: "",
      quantity: "",
      rate: "",
      amount: "",
      uomId: "",
      itemList: [], // filtered item list per row
      itemCategoryList: [],
    },
  ]);
  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    if (isNaN(date)) return "N/A";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const [itemtype, setItemType] = useState([]);
  const [itemcategoryd, setItemCategory] = useState([]);
  const [itemd, setItemList] = useState([]);
  const previousTableData = UsePrevious(tableData);
  const mstclientId = sessionStorage.getItem("MstClientId");





  const updateTableData = async (formatted) => {
    if (JSON.stringify(previousTableData) !== JSON.stringify(formatted)) {
      const updatedTableData = [...formatted];
      for (const row of updatedTableData) {
        if (row?.itemType) {
          const filteredCategories = itemcategoryd
            .filter((item) => item.MstItemTypeId === row.itemType)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
        }

        if (row?.itemCategoryId) {
          const filteredItems = itemd
            .filter((item) => item.MstItemCategoryId === row.itemCategoryId)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;

          const selectedItem = filteredItems.find(
            (item) => item.value === parseInt(row.itemId)
          );
          row.uomId = selectedItem?.uom || "";
        }
      }

      setTableData(updatedTableData);
    }
  };

  useEffect(() => {
    

    BindReceipt();
    if (data1.length !== 0) {
      appendDataToTable(data1); // pass array directly
    } else {
      setTableData([
        ...tableData,
        {
          itemType: "",
          itemcategory: "",
          itemname: "",
          uom: "",
          amount: "",
          quantity: "",
          itemcategoryList: [],
          itemList: [],
        },
      ]);
    }
  }, [data1]);
  const BindReceipt = async () => {
    
    const requestData = {
      mstClientId: mstclientId,
    };

    const response = await BindPostAPI(requestData, "ReceiptAPI/BindReceipt");
    if (response && response.data) {
      console.log(response);
      const ItemTypes = response.data.Table1.map((item) => ({
        value: item.MstItemTypeId,
        label: item.ItemType,
      }));
      console.log("Itamedata", response.data);
      setItemType(ItemTypes);
      setItemCategory(response.data.Table2);
      setItemList(response.data.Table3);

      console.log(response.data.Table2);
      console.log(response.data.Table3);
    }
  };
  const appendDataToTable = (newData) => {
    
    let newDataArray;

    if (Array.isArray(newData)) {
      newDataArray = newData;
    } else if (typeof newData === "string") {
      try {
        newDataArray = JSON.parse(newData);
      } catch (err) {
        console.error("Invalid JSON string passed to appendDataToTable", err);
        return;
      }
    } else {
      console.error("appendDataToTable expected array or JSON string but got:", newData);
      return;
    }

    // Reset table
    setTableData([]);

    const formatted = newDataArray.map((item) => ({
      itemType: item.itemType,
      itemCategoryId: item.itemCategoryId,
      itemId: item.itemName,
      quantity: item.quantity,
      uomId: item.uom, // ✅ fix key
      rate: item.rate,
      amount: item.quantity && item.rate ? item.quantity * item.rate : "",
      itemCategoryList: [], // will be populated in updateTableData
      itemList: [],
    }));

    setTableData(formatted);
    updateTableData(formatted); // populate category & item lists
  };

  const handleDeleteRow = (index) => {
    if (tableData.length > 1) {
      const updated = [...tableData];
      updated.splice(index, 1);
      setTableData(updated);
    }
  };


  return (
    <div className="w-full">
      <form className="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh]">
        {/* Header Inputs */}
        <div className={mainTable.grid4}>
          <InputText title="Purchase Id" name="purchaseId" content={data?.PurchaseId || ""} disabled />
          <InputText title="Purchase Date" name="purchaseDate" content={data?.FormattedDate || formatDate(data?.PurchaseDate)} disabled classStar="text-red-500" />
          <InputText title="Purchase Type" name="purchaseType" content={data?.PurchaseTypeLabel || ""} disabled classStar="text-red-500" />
          <InputText title="Supplier Name" name="supplierName" content={data?.SupplierName || ""} disabled classStar="text-red-500" />
          <InputText title="Address" name="address" content={data?.Address || ""} disabled classStar="text-red-500" />
          <InputText title="Country" name="country" content={data?.CountryName || ""} disabled classStar="text-red-500" />
          <InputText title="State" name="state" content={data?.State || ""} disabled classStar="text-red-500" />
          <InputText title="City" name="city" content={data?.City || ""} disabled classStar="text-red-500" />
          <InputText title="Pincode" name="pincode" content={data?.Pincode || ""} disabled classStar="text-red-500" />
          <InputText title="Contact Person" name="contactPerson" content={data?.ContactPerson || ""} disabled classStar="text-red-500" />
          <InputText title="Designation" name="designation" content={data?.Designation || ""} disabled classStar="text-red-500" />
          <InputText title="Mobile Number" name="mobileNumber" content={data?.MobileNumber || ""} disabled classStar="text-red-500" />
        </div>

        {/* Items Table */}
        <div className="w-full max-h-[400px] mt-6">
          <table className="w-full border border-gray-300">
            <thead className="bg-[#3D6643] text-white sticky top-0 z-10">
              <tr>
                <th className="border px-2 py-2 w-[30px]">SN</th>
                <th className="border px-4 py-2 w-[200px]">Item Type</th>
                <th className="border px-4 py-2 w-[200px]">Category</th>
                <th className="border px-4 py-2 w-[230px]">Name</th>
                <th className="border px-4 py-2 w-[90px]">Quantity</th>
                <th className="border px-4 py-2 w-[100px]">U.O.M</th>
                <th className="border px-4 py-2 w-[100px]">Rate</th>
                <th className="border px-4 py-2 w-[100px]">Amount</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  <td className="border px-1 py-2 text-center">{index + 1}</td>

                  <td className="border px-2 py-2">
                    <AutoDropDown
                      name="itemType"
                      Class="custom-class"
                      disabled={true}
                      options={itemtype || []}
                      selectedOption={
                        row.itemType
                          ? itemtype.find((x) => x.value == row.itemType)
                          : ""
                      }
                      placeholder="Select"
                    />
                  </td>

                  <td className="border px-2 py-2">
                    <AutoDropDown
                      name="itemcategory"
                      Class="custom-class"
                      disabled={true}
                      options={row.itemCategoryList}
                      selectedOption={
                        row.itemCategoryId
                          ? row.itemCategoryList.find((x) => String(x.value) === String(row.itemCategoryId))
                          : ""
                      }
                      placeholder="Select"
                    />
                  </td>

                  <td className="border px-2 py-2">
                    <AutoDropDown
                      name="itemname"
                      Class="custom-class"
                      disabled={true}
                      options={row.itemList}
                      selectedOption={
                        row.itemId ? row.itemList.find((x) => String(x.value) === String(row.itemId)) : ""
                      }
                      placeholder="Select"
                    />
                  </td>

                  <td className="border px-2 py-2">
                    <InputText inputType="number" name="quantity" content={row.quantity} disabled />
                  </td>

                  <td className="border px-2 py-2">
                    <InputText inputType="text" name="uom" content={row.uomId} disabled />
                  </td>

                  <td className="border px-2 py-2">
                    <InputText inputType="text" name="rate" content={row.rate} disabled />
                  </td>

                  <td className="border px-2 py-2">
                    <InputText
                      inputType="text"
                      name="amount"
                      content={row.amount ?? (row.quantity && row.rate ? row.quantity * row.rate : "")}
                      disabled
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Remarks */}
        <div className="mt-4">
          <TextArea
            title="Remarks"
            name="remarks"
            content={data?.Remarks || ""}
            rows="4"
            disabled
            maxlength={500}
          />
        </div>
      </form>
    </div>
  );
};

export default PurchasePopup;
